import React, {useState} from 'react';
import {Card as BpCard, Collapse, Icon} from "@blueprintjs/core";
import styled from "styled-components";

const INTENT_STYLES = {
    primary: {bg: 'rgba(45, 114, 210, 0.1)', color: '#215db0', border: '#215db0'},
    success: {bg: 'rgba(35, 133, 81, 0.1)', color: '#1c6e42', border: '#1c6e42'},
    warning: {bg: 'rgba(200, 118, 25, 0.1)', color: '#935610', border: '#935610'},
    danger:  {bg: 'rgba(205, 66, 70, 0.1)',  color: '#ac2f33', border: '#ac2f33'},
};

const StyledCard = styled(BpCard)`
    border-radius: 8px;
    padding: 1em;
    ${({$intent}) => {
        const s = INTENT_STYLES[$intent];
        return s ? `background-color: ${s.bg};` : '';
    }}
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: ${({$disabled}) => $disabled ? 'not-allowed' : 'pointer'};
    opacity: ${({$disabled}) => $disabled ? 0.5 : 1};
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
    min-height: 44px;
`;

const Title = styled.span`
    font-weight: 600;
    font-size: 1em;
    ${({$intent}) => {
        const s = INTENT_STYLES[$intent];
        return s ? `color: ${s.color};` : '';
    }}
`;

const Card = ({title, intent, disabled = false, children}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <StyledCard $intent={intent} elevation={2}>
            <Header
                $disabled={disabled}
                title={disabled ? `${title} is disabled` : isOpen ? `Collapse ${title}` : `Expand ${title}`}
                onClick={() => !disabled && setIsOpen(prev => !prev)}
            >
                <Title $intent={intent}>{title}</Title>
                <Icon icon={isOpen ? "caret-up" : "caret-down"} />
            </Header>
            <Collapse isOpen={isOpen}>
                <div style={{paddingTop: '1em'}}>
                    {children}
                </div>
            </Collapse>
        </StyledCard>
    );
}

export {Card};
